var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.42 18.345 v 68.502 c 0 1.741 -1.412 3.153 -3.153 3.153 H 14.733 c -1.741 0 -3.153 -1.412 -3.153 -3.153 V 3.153 C 11.58 1.412 12.991 0 14.733 0 h 45.343 C 63.133 7.61 69.386 13.658 78.42 18.345 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(233,233,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.42 18.345 H 62.948 c -1.587 0 -2.873 -1.286 -2.873 -2.873 V 0 L 78.42 18.345 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#0473EA",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.163 32.067 c -2.418 -1.599 -5.324 -2.16 -8.182 -1.576 c -2.858 0.583 -5.313 2.236 -6.912 4.654 c -0.457 0.691 -0.267 1.622 0.424 2.079 c 0.689 0.456 1.621 0.267 2.078 -0.424 c 1.157 -1.75 2.936 -2.946 5.008 -3.369 c 2.073 -0.421 4.178 -0.019 5.929 1.138 c 3.63 2.4 4.63 7.306 2.23 10.936 L 42.428 73.2 c -1.157 1.749 -2.936 2.945 -5.008 3.368 c -2.076 0.423 -4.179 0.017 -5.928 -1.139 c -1.75 -1.157 -2.946 -2.936 -3.369 -5.008 c -0.423 -2.072 -0.019 -4.176 1.137 -5.926 c 0.001 -0.001 0.001 -0.001 0.002 -0.002 l 12.601 -19.059 c 0.938 -1.42 2.858 -1.812 4.278 -0.872 c 0.684 0.452 1.151 1.147 1.316 1.958 c 0.165 0.812 0.008 1.635 -0.444 2.318 L 34.527 67.724 c -0.457 0.69 -0.267 1.621 0.424 2.078 c 0.254 0.169 0.542 0.249 0.826 0.249 c 0.487 0 0.964 -0.236 1.253 -0.673 l 12.485 -18.884 c 0.895 -1.352 1.207 -2.976 0.882 -4.572 c -0.325 -1.596 -1.249 -2.968 -2.602 -3.861 c -2.798 -1.853 -6.582 -1.081 -8.435 1.72 L 26.759 62.84 c -0.002 0.002 -0.002 0.005 -0.004 0.007 c -3.307 5.008 -1.925 11.774 3.083 15.085 c 1.845 1.22 3.928 1.804 5.99 1.804 c 3.537 -0.001 7.01 -1.717 9.102 -4.882 L 63.241 47.16 C 66.554 42.151 65.173 35.38 60.163 32.067 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#0473EA",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.94c9214de476421a7fe6c9f81bf39637.svg";
export { ForwardRef as ReactComponent };